<div class="carousel-container">
   
    <div class="carousel">
      <div class="carousel-inner">
        <ng-container *ngFor="let component of updateCurrentCards() ">
          <div class="carousel-item">
            <!-- Dynamic content -->
           <app-dynamic-content [cardData]='component'></app-dynamic-content>
          </div>
        </ng-container>
      </div>
    </div>
    <button class="control prev"  Title="Previous" [ngClass]="{ disabledLink: rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex == 0}" (click)="prev()"><i class="fa-light fa-chevron-left"></i></button>
    <button class="control next"  Title="Next" [ngClass]="{ disabledLink: cardComponents && rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex == cardComponents.length - 1 }" (click)="next()"><i class="fa-light fa-chevron-right"></i></button>
    <div class="selectors">
      <button *ngFor="let component of cardComponents; let i = index" [class.selected]="i === rootScope.clientInfoCard.clientInfoCardDefaultServiceIndex" (click)="selectItem(i)"></button>
    </div>
  </div>
  